import { SubText, Text } from '@procurify/ui'

import { type ConversationDetailTextBlock } from '../../value-objects/ConversationTurnItem'
import { ConversationMarkdown } from '../ConversationMarkdown'
import { CatalogItemDetailsAnalysisTextStyled } from './styles/CatalogItemDetailsAnalysisTextStyled'

export interface ICatalogItemDetailsTextBlockProps {
  block: ConversationDetailTextBlock
  isCallout: boolean
}

export const CatalogItemDetailsTextBlock = ({
  block,
  isCallout,
}: ICatalogItemDetailsTextBlockProps) => {
  if (block.variant === 'caption') {
    return (
      <SubText color='textSecondary' className='fs-mask'>
        <ConversationMarkdown content={block.content} isInline />
      </SubText>
    )
  }
  if (isCallout) {
    return (
      <CatalogItemDetailsAnalysisTextStyled className='fs-mask'>
        <ConversationMarkdown content={block.content} isInline />
      </CatalogItemDetailsAnalysisTextStyled>
    )
  }
  return (
    <Text className='fs-mask'>
      <ConversationMarkdown content={block.content} isInline />
    </Text>
  )
}
